import Vue from 'vue'
import i18n from './i18n'
import router from './router'
import PortalVue from 'portal-vue'
import api from './plugins/api'
import App from './App.vue'
import Modal from '@/components/Modal'
import CandidateDetails from '@/components/CandidateDetails'
import Embed from '@/components/Embed'
import Spinner from '@/components/Spinner'
import IconNav from '@/components/IconNav'
import IconNavItem from '@/components/IconNavItem'
import Card from '@/components/Card'
import Notify from '@/components/Notify'
import Badge from '@/components/Badge'
import InputfieldForm from '@/components/forms/InputfieldForm'
import InputfieldErrors from '@/components/forms/InputfieldErrors'
import InputfieldFieldset from '@/components/forms/InputfieldFieldset'
import InputfieldButton from '@/components/forms/InputfieldButton'
import InputfieldButtonSet from '@/components/forms/InputfieldButtonSet'
import InputfieldText from '@/components/forms/InputfieldText'
import InputfieldTextarea from '@/components/forms/InputfieldTextarea'
import InputfieldCheckbox from '@/components/forms/InputfieldCheckbox'
import InputfieldRadio from '@/components/forms/InputfieldRadio'
import InputfieldSelect from '@/components/forms/InputfieldSelect'
import InputfieldAutoComplete from '@/components/forms/InputfieldAutoComplete'
import InputfieldRange from '@/components/forms/InputfieldRange'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faCircleNotch,
  faTimes,
  faAngleLeft,
  faHeart,
  faShare,
  faHome,
  faCopy,
  faIdCardClip,
  faEuroSign
} from '@fortawesome/free-solid-svg-icons'

import {
  faFacebookSquare,
  faTwitter,
  faXTwitter,
  faBluesky,
  faInstagram,
  faTiktok,
  faYoutube,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faCircleNotch,
  faTimes,
  faAngleLeft,
  faHeart,
  faShare,
  faHome,
  faCopy,
  faIdCardClip,
  faEuroSign,
  faFacebookSquare,
  faTwitter,
  faXTwitter,
  faBluesky,
  faInstagram,
  faTiktok,
  faYoutube,
  faLinkedin
)

// Plugins
Vue.use(PortalVue)
Vue.use(api)

// Global component
Vue.component('Modal', Modal)
Vue.component('Spinner', Spinner)
Vue.component('IconNav', IconNav)
Vue.component('IconNavItem', IconNavItem)
Vue.component('Card', Card)
Vue.component('Notify', Notify)
Vue.component('Badge', Badge)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('CandidateDetails', CandidateDetails)
Vue.component('Embed', Embed)
Vue.component('InputfieldForm', InputfieldForm)
Vue.component('InputfieldErrors', InputfieldErrors)
Vue.component('InputfieldFieldset', InputfieldFieldset)
Vue.component('InputfieldButton', InputfieldButton)
Vue.component('InputfieldButtonSet', InputfieldButtonSet)
Vue.component('InputfieldText', InputfieldText)
Vue.component('InputfieldTextarea', InputfieldTextarea)
Vue.component('InputfieldCheckbox', InputfieldCheckbox)
Vue.component('InputfieldRadio', InputfieldRadio)
Vue.component('InputfieldSelect', InputfieldSelect)
Vue.component('InputfieldAutoComplete', InputfieldAutoComplete)
Vue.component('InputfieldRange', InputfieldRange)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#kd-ehdokasgalleria')
